import * as Yup from 'yup';
import { TranslationProps } from 'ff-shared-components-core';
import { FileUploadType } from '@shared/components';

export const userDataSchema = (
	props: TranslationProps
): Yup.ObjectSchema<Yup.Shape<
	object,
	{
		idDocumentNumber: string;
		shortName: string;
		email: string;
		phone: string;
		phonePrefix: string;
		profileAccess: string;
		identificationFile: object;
	}
>> => {
	const { t } = props;
	const required: string = t('errors.form.required');
	const contain9d: string = t('errors.form.must-contain-9d');

	return Yup.object().shape({
		idDocumentNumber: Yup.string()
			// .matches(/\d{9}/, contain9d)
			.required(required),
		shortName: Yup.string()
			.min(2, t('errors.form.min-length'))
			.max(50, t('errors.form.max-length'))
			.required(required),
		email: Yup.string()
			.min(5, t('errors.form.min-length'))
			.max(100, t('errors.form.max-length'))
			.email(t('errors.form.validEmail'))
			.required(required),
		phone: Yup.string()
			.required(required)
			.matches(/\d{9}/, contain9d)
			.max(9, contain9d),
		phonePrefix: Yup.string()
			.matches(/^[+][0-9]{2,3}$/, t('errors.form.not-valid'))
			.max(4, t('errors.form.not-valid'))
			.required(required),
		profileAccess: Yup.string().required(required),
		identificationFile: Yup.object()
			.nullable()
			.shape({
				name: Yup.string().required(t('errors.form.file-validation.name')),
				// type: Yup.string().required(t('errors.form.file-validation.type')),
				// base64File: Yup.string().required(t('errors.form.file-validation.base64File')),
			})
			.required(t('errors.form.file-validation.required')),
	});
};
